import * as Types from '../../../graphql-types'

import { gql } from '@apollo/client'
import { Common_ContentProviderFragmentFragmentDoc } from './CommonContentProviderFragment.generated'
export type Common_ContentFragmentFragment = {
  __typename?: 'Content'
  id?: string | null
  contentId?: number | null
  contentType?: string | null
  published?: boolean | null
  publishedAtDate?: any | null
  createdAt?: any | null
  updatedAt?: any | null
  title?: string | null
  path?: string | null
  shortDescription?: string | null
  description?: string | null
  language?: string | null
  contentPolicyPolicyId?: number | null
  contentProvider?: {
    __typename?: 'ContentProvider'
    provider?: Types.ContentProviderProviders | null
    providerKey?: string | null
    contentId?: string | null
  } | null
}

export const Common_ContentFragmentFragmentDoc = gql`
  fragment Common_ContentFragment on Content {
    id
    contentId
    contentType
    published
    publishedAtDate
    createdAt
    updatedAt
    title
    path
    shortDescription
    description
    language
    contentPolicyPolicyId
    ...Common_ContentProviderFragment
  }
  ${Common_ContentProviderFragmentFragmentDoc}
`
